import React from "react";
import { BottomSheet } from "@/components/BottomSheet";
import { Trash2 } from "lucide-react";

export const ConfirmSheet = ({ open, onClose, onConfirm, title, message, confirmLabel = "Delete", busy, testid = "confirm-sheet" }) => (
  <BottomSheet open={open} onClose={onClose} title={title} testid={testid}>
    <p className="text-sm text-muted-foreground -mt-1 mb-4 leading-relaxed">{message}</p>
    <div className="flex flex-col gap-2">
      <button data-testid={`${testid}-confirm`} disabled={busy} onClick={onConfirm} className="w-full bg-error text-white rounded-full h-12 font-heading font-bold flex items-center justify-center gap-2 active:scale-[0.98] transition-transform disabled:opacity-50">
        <Trash2 size={17} /> {busy ? "Deleting…" : confirmLabel}
      </button>
      <button data-testid={`${testid}-cancel`} disabled={busy} onClick={onClose} className="w-full bg-surface border border-border text-onSurface rounded-full h-12 font-heading font-bold active:scale-[0.98] transition-transform disabled:opacity-50">
        Cancel
      </button>
    </div>
  </BottomSheet>
);
